

import reactNative from '../assets/ReactNative.jpg'
import reactNative2 from "../assets/ReactNative2.jpg";
import agile from "../assets/Agile.jpg";
import javaScript from "../assets/JavaScript.jpg";
import data from "../assets/Data.jpg";
import mobiledev from "../assets/mobiledev.jpg";
import version from "../assets/version.jpg";
import uiux from "../assets/uiux.jpg";
export const certs = [
    {

        id: 1,
        title: 'React Native',
        date: 'April 2023',
        credential: '7EANQHA8WPAK',
        info: 'Creating a React Native app by styling components, handling large lists, managing user inputs and implementing screen navigation with React Navigation.',
        link: 'https://www.coursera.org/account/accomplishments/certificate/7EANQHA8WPAK',
        image: reactNative2
    }, {

        id: 2,
        title: 'React Basics',
        date: 'April 2023',
        credential: 'R36NW77SMMH4',
        info: 'Use reusable components to manage changing data, organize React projects for scalability, pass data with props, create dynamic web pages, use forms for user interaction, and build complete applications in React.',
        link: 'https://www.coursera.org/account/accomplishments/certificate/R36NW77SMMH4',
        image: reactNative
    }, {

        id: 3,
        title: 'Agile Development and Scrum',
        date: 'April 2023',
        credential: '8HZLEG2YQAZ3',
        info: 'Adopt Agile practices: work in small batches, create MVPs, use pair programming, write user stories, and track with a kanban board. Implement Scrum, plan sprints, deliver increments, and use metrics to improve performance.',
        link: 'https://www.coursera.org/account/accomplishments/certificate/8HZLEG2YQAZ3',
        image: agile
    }, {

        id: 4,
        title: 'Programming with JavaScript',
        date: 'April 2023',
        credential: 'TTFHZFZKEKZN',
        info: 'Creating simple JavaScript codes. Creating and manipulating objects and arrays. Writing unit tests using Jest ',
        link: 'https://www.coursera.org/account/accomplishments/certificate/TTFHZFZKEKZN',
        image: javaScript
    }
    , {

        id: 5,
        title: 'Working with Data',
        date: 'April 2023',
        credential: '3J3H5SLJDV59',
        info: 'Learn what REST APIs are and best practices for using them. Make network calls to retrieve data, create databases with SQL, and store data using AsyncStorage and SQLite in a mobile application.',
        link: 'https://www.coursera.org/account/accomplishments/certificate/3J3H5SLJDV59',
        image: data
    }
    , {

        id: 6,
        title: 'Mobile Development',
        date: 'April 2023',
        credential: '95V7H7SE4JC6',
        info: 'The role of a cross-platform mobile developer. Creating a simple webpage using HTML5. Styling a web page using CSS. Explaining React and React Native',
        link: 'https://www.coursera.org/account/accomplishments/certificate/95V7H7SE4JC6',
        image: mobiledev
    }
    , {

        id: 7,
        title: 'Version Control',
        date: 'April 2023',
        credential: '8AGYGEKM83ZK',
        info: 'Implement Version Control systems. Navigate and configure using the command line. Use a GitHub repository. Create a GitHub repository. Manage code revisions.',
        link: 'https://www.coursera.org/account/accomplishments/certificate/8AGYGEKM83ZK',
        image: version
    }, {

        id: 8,
        title: 'Principles of UX/UI Design',
        date: 'April 2023',
        credential: 'FQCZNNGTD3B9',
        info: 'Describe the fundamentals of User Experience (UX) design and research. Describe accessibility considerations in design. Practice developing user empathy through research. Create wireframes and prototypes in Figma.',
        link: 'https://www.coursera.org/account/accomplishments/certificate/FQCZNNGTD3B9',
        image: uiux
    }
];
